import { Box, Group, Radio } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { TFunction } from 'i18next';

import InputLabel from 'components/input/label';

interface YesNoRadioButtonProps<T> {
  name: string;
  label: string;
  t: TFunction;
  form: UseFormReturnType<T>;
  disabled?: boolean;
  required?: boolean;
  onChange?: (value: boolean) => void;
}

const YesNoRadioButton = <T,>(props: YesNoRadioButtonProps<T>) => {
  const { t, form, name, label, disabled, onChange } = props;

  const checked = (val: boolean) => form.getInputProps(name).defaultValue === val;

  return (
    <Box>
      <InputLabel label={label} required={props.required} />
      <Group mt={'xs'}>
        <Radio
          checked={checked(true)}
          onChange={() => {
            form.setFieldValue(name, true as any);
            onChange?.(true);
          }}
          label={t('yes')}
          disabled={disabled}
        />
        <Radio
          checked={checked(false)}
          onChange={() => {
            form.setFieldValue(name, false as any);
            onChange?.(false);
          }}
          label={t('no')}
          disabled={disabled}
        />
      </Group>
    </Box>
  );
};

export default YesNoRadioButton;
